/**
 * 空间管理：左侧纵向 Tabs + 右侧 Panel（单页 + URL tab 参数）。
 */
import { Tabs } from '@heroui/react';
import { useSearchParams } from 'react-router-dom';
import { SpaceSettingsPanel } from './components/SpaceSettingsPanel';
import { MemberManagementPanel } from './components/MemberManagementPanel';
import { SpaceAppsPanel } from './components/SpaceAppsPanel';
import { SpacePlanPanel } from './components/SpacePlanPanel';
import { SpaceEntitlementPanel } from './components/SpaceEntitlementPanel';

export const ADMIN_TAB_SPACE_SETTINGS = 'space-settings';
export const ADMIN_TAB_MEMBER_MANAGEMENT = 'member-management';
export const ADMIN_TAB_SPACE_APPS = 'space-apps';
export const ADMIN_TAB_SPACE_PLAN = 'space-plan';
export const ADMIN_TAB_SPACE_ENTITLEMENT = 'space-entitlement';

const VALID_TABS = new Set([
  ADMIN_TAB_SPACE_SETTINGS,
  ADMIN_TAB_MEMBER_MANAGEMENT,
  ADMIN_TAB_SPACE_APPS,
  ADMIN_TAB_SPACE_PLAN,
  ADMIN_TAB_SPACE_ENTITLEMENT,
]);

export default function AdminPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('tab') ?? ADMIN_TAB_SPACE_SETTINGS;
  const selectedKey = VALID_TABS.has(raw) ? raw : ADMIN_TAB_SPACE_SETTINGS;

  return (
    <div className="flex h-full min-h-0 flex-col bg-background p-4">
      <Tabs
        orientation="vertical"
        selectedKey={selectedKey}
        className="flex min-h-0 flex-1 flex-row gap-0"
        onSelectionChange={(key) => {
          const k = String(key);
          setSearchParams({ tab: k }, { replace: true });
        }}
      >
        <Tabs.ListContainer>
          <Tabs.List aria-label="空间管理">
            <Tabs.Tab id={ADMIN_TAB_SPACE_SETTINGS}>
              空间设置
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={ADMIN_TAB_SPACE_PLAN}>
              订阅管理
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={ADMIN_TAB_SPACE_ENTITLEMENT}>
              权益管理
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={ADMIN_TAB_MEMBER_MANAGEMENT}>
              成员管理
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={ADMIN_TAB_SPACE_APPS}>
              应用管理
              <Tabs.Indicator />
            </Tabs.Tab>
          </Tabs.List>
        </Tabs.ListContainer>
        <Tabs.Panel
          id={ADMIN_TAB_SPACE_SETTINGS}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <SpaceSettingsPanel />
        </Tabs.Panel>
        <Tabs.Panel
          id={ADMIN_TAB_SPACE_PLAN}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <SpacePlanPanel />
        </Tabs.Panel>
        <Tabs.Panel
          id={ADMIN_TAB_SPACE_ENTITLEMENT}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <SpaceEntitlementPanel />
        </Tabs.Panel>
        <Tabs.Panel
          id={ADMIN_TAB_MEMBER_MANAGEMENT}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <MemberManagementPanel />
        </Tabs.Panel>
        <Tabs.Panel
          id={ADMIN_TAB_SPACE_APPS}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-0"
        >
          <SpaceAppsPanel />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
}
